import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { notificar } from '../utils/notify';
import '../styles/ContagemContabil.css';

const Contagemcontabilidade = () => {
  // Estados para gerenciar dados e UI
  const [empresas, setEmpresas] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [mensagem, setMensagem] = useState('');
  useEffect(() => { notificar(mensagem); }, [mensagem]);
  const [filtros, setFiltros] = useState({
    numero_dominio: '',
    empresa: '',
    operador: ''
  });
  const [historicoTempo, setHistoricoTempo] = useState([]);
  const [carregandoHistorico, setCarregandoHistorico] = useState(false);
  const [contagensAtivas, setContagensAtivas] = useState({});
  const [tempoDecorrido, setTempoDecorrido] = useState({});
  const [operadoresUnicos, setOperadoresUnicos] = useState([]);
  const [resumoPorEmpresa, setResumoPorEmpresa] = useState([]);
  const [filtroHistorico, setFiltroHistorico] = useState('');
  const [tabAtiva, setTabAtiva] = useState('empresas');
  
  // Estados para edição
  const [editandoTempo, setEditandoTempo] = useState(null);
  const [novoTempo, setNovoTempo] = useState({ horas: 0, minutos: 0, segundos: 0 });
  const [mostrarModalEdicao, setMostrarModalEdicao] = useState(false);

  // Determinar o nome do usuário
  const token = localStorage.getItem('access');
  let username = 'usuário';

  if (token) {
    try {
      const decoded = jwtDecode(token);
      username = decoded.first_name || decoded.username || decoded.sub || 'usuário';
    } catch (e) {
      console.error('Erro ao decodificar token:', e);
    }
  }

  // Carregar empresas
  useEffect(() => {
    carregarEmpresas();
    carregarHistoricoTempo();
  }, []);

  // Atualizar tempo decorrido a cada segundo para contagens ativas
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const novoTempoDecorrido = { ...tempoDecorrido };

      Object.keys(contagensAtivas).forEach(numero_dominio => {
        if (contagensAtivas[numero_dominio]) {
          const inicio = new Date(contagensAtivas[numero_dominio]);
          const diff = Math.floor((now - inicio) / 1000);
          
          const horas = Math.floor(diff / 3600);
          const minutos = Math.floor((diff % 3600) / 60);
          const segundos = diff % 60;
          
          novoTempoDecorrido[numero_dominio] = `${horas.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}:${segundos.toString().padStart(2, '0')}`;
        }
      });

      setTempoDecorrido(novoTempoDecorrido);
    }, 1000);

    return () => clearInterval(interval);
  }, [contagensAtivas]);

  const carregarEmpresas = () => {
    setCarregando(true);
    setMensagem('');

    const accessToken = localStorage.getItem('access');

    axios
      .get(`${process.env.REACT_APP_API_BASE}/api/empresas-contabil/`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      })
      .then((res) => {
        const empresasCarregadas = res.data.empresas || [];
        setEmpresas(empresasCarregadas);
        
        // Extrair operadores únicos
        const operadoresUnicos = [...new Set(empresasCarregadas.map(emp => emp.operador).filter(Boolean))].sort();
        setOperadoresUnicos(operadoresUnicos);
        
        setCarregando(false);
        verificarContagensAtivas(empresasCarregadas);
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.erro ||
          error.response?.data?.mensagem ||
          error.message ||
          'Erro desconhecido ao carregar empresas';
        setMensagem(`Erro: ${errorMsg}`);
        setCarregando(false);
      });
  };

  // Verificar se existem contagens ativas ao carregar a página
  const verificarContagensAtivas = (empresasCarregadas) => {
    const accessToken = localStorage.getItem('access');
    
    axios
      .get(`${process.env.REACT_APP_API_BASE}/api/contagens-ativas/?usuario=${username}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      })
      .then((res) => {
        const contagensAtivas = {};
        res.data.contagens.forEach(contagem => {
          contagensAtivas[contagem.numero_dominio] = contagem.data_inicio;
        });
        setContagensAtivas(contagensAtivas);
      })
      .catch((error) => {
        console.error("Erro ao verificar contagens ativas:", error);
      });
  };

  // Carregar histórico de tempo - VERSÃO MELHORADA
  const carregarHistoricoTempo = () => {
    setCarregandoHistorico(true);
    const accessToken = localStorage.getItem('access');
    
    axios
      .get(`${process.env.REACT_APP_API_BASE}/api/historico-tempo/`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      })
      .then((res) => {
        setHistoricoTempo(res.data.historico);
        setCarregandoHistorico(false);
        
        // Calcular resumo por empresa
        if (res.data.historico && res.data.historico.length > 0) {
          calcularResumoPorEmpresa(res.data.historico);
        } else {
          setResumoPorEmpresa([]);
        }
      })
      .catch((error) => {
        const errorMsg = 
          error.response?.data?.erro ||
          error.message ||
          'Erro ao carregar histórico';
        setMensagem(`Erro: ${errorMsg}`);
        setCarregandoHistorico(false);
      });
  };

  // Calcular resumo de tempo por empresa - VERSÃO CORRIGIDA
  const calcularResumoPorEmpresa = (historico) => {
    const resumo = {};
    
    // Filtrar apenas registros concluídos
    const historicoCompleto = historico.filter(item => 
      item.status === 'Concluído' && 
      item.duracao_segundos && 
      item.duracao_segundos > 0
    );
    
    historicoCompleto.forEach(item => {
      const chave = item.numero_dominio;
      
      if (!resumo[chave]) {
        resumo[chave] = {
          numero_dominio: item.numero_dominio,
          empresa: item.empresa,
          tempo_total_segundos: 0,
          registros: 0
        };
      }
      
      // Usar duracao_segundos diretamente do banco de dados
      resumo[chave].tempo_total_segundos += item.duracao_segundos;
      resumo[chave].registros += 1;
    });
    
    // Converter para array e formatar o tempo total
    const resumoArray = Object.values(resumo).map(item => {
      const horas = Math.floor(item.tempo_total_segundos / 3600);
      const minutos = Math.floor((item.tempo_total_segundos % 3600) / 60);
      const segundos = item.tempo_total_segundos % 60;
      
      const tempoMedioSegundos = Math.floor(item.tempo_total_segundos / item.registros);
      const horasMedia = Math.floor(tempoMedioSegundos / 3600);
      const minutosMedia = Math.floor((tempoMedioSegundos % 3600) / 60);
      const segundosMediaRestante = tempoMedioSegundos % 60;
      
      return {
        ...item,
        tempo_total_formatado: `${horas}h ${minutos}m ${segundos}s`,
        tempo_medio_formatado: `${horasMedia}h ${minutosMedia}m ${segundosMediaRestante}s`
      };
    });
    
    // Ordenar por tempo total (decrescente)
    resumoArray.sort((a, b) => b.tempo_total_segundos - a.tempo_total_segundos);
    
    setResumoPorEmpresa(resumoArray);
  };

  // Iniciar contagem de tempo
  const iniciarContagem = (empresa) => {
    const accessToken = localStorage.getItem('access');
    
    axios
      .post(
        `${process.env.REACT_APP_API_BASE}/api/iniciar-contagem/`, 
        {
          numero_dominio: empresa.numero_dominio,
          empresa: empresa.empresa,
          usuario: username
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` }
        }
      )
      .then((res) => {
        setMensagem(`Contagem iniciada para ${empresa.empresa}`);
        
        // Atualizar o estado das contagens ativas
        setContagensAtivas(prev => ({
          ...prev,
          [empresa.numero_dominio]: new Date().toISOString()
        }));
        
        // Inicializar o tempo decorrido
        setTempoDecorrido(prev => ({
          ...prev,
          [empresa.numero_dominio]: '00:00:00'
        }));
      })
      .catch((error) => {
        const errorMsg = 
          error.response?.data?.erro ||
          error.message ||
          'Erro ao iniciar contagem';
        setMensagem(`Erro: ${errorMsg}`);
      });
  };

  // Parar contagem de tempo
  const pararContagem = (empresa) => {
    const accessToken = localStorage.getItem('access');
    
    axios
      .post(
        `${process.env.REACT_APP_API_BASE}/api/parar-contagem/`, 
        {
          numero_dominio: empresa.numero_dominio,
          usuario: username
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` }
        }
      )
      .then(() => {
        setMensagem(`Contagem finalizada para ${empresa.empresa}`);
        
        // Remover da lista de contagens ativas
        const novasContagensAtivas = { ...contagensAtivas };
        delete novasContagensAtivas[empresa.numero_dominio];
        setContagensAtivas(novasContagensAtivas);
        
        // Remover do tempo decorrido
        const novoTempoDecorrido = { ...tempoDecorrido };
        delete novoTempoDecorrido[empresa.numero_dominio];
        setTempoDecorrido(novoTempoDecorrido);
        
        // Recarregar o histórico
        carregarHistoricoTempo();
      })
      .catch((error) => {
        const errorMsg = 
          error.response?.data?.erro ||
          error.message ||
          'Erro ao parar contagem';
        setMensagem(`Erro: ${errorMsg}`);
      });
  };

  // FUNÇÕES DE EDIÇÃO
  const abrirModalEdicao = (item) => {
    // Extrair horas, minutos e segundos da duração atual
    const partes = item.duracao.split(' ');
    let horas = 0, minutos = 0, segundos = 0;
    
    partes.forEach(parte => {
      if (parte.includes('h')) {
        horas = parseInt(parte.replace('h', ''));
      } else if (parte.includes('m')) {
        minutos = parseInt(parte.replace('m', ''));
      } else if (parte.includes('s')) {
        segundos = parseInt(parte.replace('s', ''));
      }
    });
    
    setEditandoTempo(item);
    setNovoTempo({ horas, minutos, segundos });
    setMostrarModalEdicao(true);
  };

  const salvarEdicaoTempo = () => {
    const accessToken = localStorage.getItem('access');
    const totalSegundos = (novoTempo.horas * 3600) + (novoTempo.minutos * 60) + novoTempo.segundos;
    
    if (totalSegundos <= 0) {
      setMensagem('Erro: O tempo deve ser maior que zero.');
      return;
    }
    
    axios
      .post(
        `${process.env.REACT_APP_API_BASE}/api/atualizar-tempo/${editandoTempo.id}/`,
        { nova_duracao_segundos: totalSegundos },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      )
      .then(() => {
        setMensagem('Tempo atualizado com sucesso!');
        setMostrarModalEdicao(false);
        setEditandoTempo(null);
        carregarHistoricoTempo(); // Recarregar dados
      })
      .catch((error) => {
        const errorMsg = 
          error.response?.data?.erro ||
          error.message ||
          'Erro ao atualizar tempo';
        setMensagem(`Erro: ${errorMsg}`);
      });
  };

  const deletarRegistroTempo = (item) => {
    if (window.confirm(`Tem certeza que deseja deletar o registro de ${item.empresa}?`)) {
      const accessToken = localStorage.getItem('access');
      
      axios
        .delete(
          `${process.env.REACT_APP_API_BASE}/api/deletar-tempo/${item.id}/`,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        )
        .then(() => {
          setMensagem('Registro deletado com sucesso!');
          carregarHistoricoTempo(); // Recarregar dados
        })
        .catch((error) => {
          const errorMsg = 
            error.response?.data?.erro ||
            error.message ||
            'Erro ao deletar registro';
          setMensagem(`Erro: ${errorMsg}`);
        });
    }
  };

  // Filtrar empresas
  const empresasFiltradas = empresas.filter((emp) => {
    return Object.entries(filtros).every(([campo, valorFiltro]) => {
      if (!valorFiltro) return true;
      const valorEmpresa = emp[campo] ? emp[campo].toString().toLowerCase() : '';
      return valorEmpresa.includes(valorFiltro.toLowerCase());
    });
  });

  // Filtrar histórico
  const historicoFiltrado = historicoTempo.filter((item) => {
    if (!filtroHistorico) return true;
    
    const filtroLower = filtroHistorico.toLowerCase();
    return (
      item.empresa.toLowerCase().includes(filtroLower) ||
      (item.usuario && item.usuario.toLowerCase().includes(filtroLower)) ||
      item.numero_dominio.toString().includes(filtroLower)
    );
  });

  return (
    <div className="contagem-contabil-page">
      <div className="container mt-5 shadow p-4 rounded bg-white">
        {/* Cabeçalho */}
        <div className="header-wrapper d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex align-items-center">
            <i className="fas fa-stopwatch header-icon me-2"></i>
            <h2 className="titulo-pagina m-0">Contagem de Tempo - {username}</h2>
          </div>
          <button 
            className="btn btn-primary"
            onClick={() => window.location.href = '/Contabilidade'}
          >
            <i className="fas fa-arrow-left me-2"></i>
            Voltar para Contabilidade
          </button>
        </div>

        {/* Mensagens agora são exibidas como toast (react-toastify) */}

        {/* Estatísticas rápidas */}
        <div className="row mb-4">
          <div className="col-md-3">
            <div className="card bg-primary text-white h-100">
              <div className="card-body d-flex align-items-center">
                <div className="flex-grow-1">
                  <h5 className="card-title mb-0">Contagens Ativas</h5>
                  <h3 className="mb-0">{Object.keys(contagensAtivas).length}</h3>
                </div>
                <i className="fas fa-play fa-2x opacity-75"></i>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card bg-primary text-white h-100">
              <div className="card-body d-flex align-items-center">
                <div className="flex-grow-1">
                  <h5 className="card-title mb-0">Total de Registros</h5>
                  <h3 className="mb-0">{historicoTempo.length}</h3>
                </div>
                <i className="fas fa-check fa-2x opacity-75"></i>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card bg-primary text-white h-100">
              <div className="card-body d-flex align-items-center">
                <div className="flex-grow-1">
                  <h5 className="card-title mb-0">Empresas com Registro</h5>
                  <h3 className="mb-0">{resumoPorEmpresa.length}</h3>
                </div>
                <i className="fas fa-building fa-2x opacity-75"></i>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card bg-primary text-white h-100">
              <div className="card-body d-flex align-items-center">
                <div className="flex-grow-1">
                  <h5 className="card-title mb-0">Empresas Cadastradas</h5>
                  <h3 className="mb-0">{empresas.length}</h3>
                </div>
                <i className="fas fa-list fa-2x opacity-75"></i>
              </div>
            </div>
          </div>
        </div>

        {/* Filtros */}
        <div className="row mb-4">
          <div className="col-md-4">
            <label className="form-label fw-bold">Empresa</label>
            <input
              type="text"
              className="form-control"
              placeholder="Filtrar por empresa..."
              value={filtros.empresa}
              onChange={(e) => setFiltros(prev => ({ ...prev, empresa: e.target.value }))}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label fw-bold">Domínio</label>
            <input
              type="text"
              className="form-control"
              placeholder="Filtrar por número de domínio..."
              value={filtros.numero_dominio}
              onChange={(e) => setFiltros(prev => ({ ...prev, numero_dominio: e.target.value }))}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label fw-bold">Operador</label>
            <select
              className="form-select"
              value={filtros.operador}
              onChange={(e) => setFiltros(prev => ({ ...prev, operador: e.target.value }))}
            >
              <option value="">Todos Operadores</option>
              {operadoresUnicos.map((operador) => (
                <option key={operador} value={operador}>
                  {operador}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Tabs */}
        <ul className="nav nav-tabs mb-3" role="tablist">
          <li className="nav-item" role="presentation">
            <button 
              className={`nav-link ${tabAtiva === 'empresas' ? 'active' : ''}`}
              onClick={() => setTabAtiva('empresas')}
              type="button" 
              role="tab"
            >
              <i className="fas fa-building me-2"></i>
              Empresas
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button 
              className={`nav-link ${tabAtiva === 'historico' ? 'active' : ''}`}
              onClick={() => {
                setTabAtiva('historico');
                carregarHistoricoTempo();
              }}
              type="button" 
              role="tab"
            >
              <i className="fas fa-history me-2"></i>
              Histórico de Tempo
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button 
              className={`nav-link ${tabAtiva === 'resumo' ? 'active' : ''}`}
              onClick={() => setTabAtiva('resumo')}
              type="button" 
              role="tab"
            >
              <i className="fas fa-chart-bar me-2"></i>
              Resumo
            </button>
          </li>
        </ul>

        <div className="tab-content">
          {/* Tab Empresas */}
          {tabAtiva === 'empresas' && (
            <div className="tab-pane-content">
              <div className="table-responsive">
                {carregando ? (
                  <div className="text-center my-5">
                    <div className="spinner-border text-primary" role="status"></div>
                    <p className="mt-2">Carregando empresas...</p>
                  </div>
                ) : (
                  <table className="table table-bordered table-hover text-center align-middle">
                    <thead className="table-light">
                      <tr>
                        <th>Nº Domínio</th>
                        <th>Empresa</th>
                        <th>Operador</th>
                        <th>Contagem</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {empresasFiltradas.length > 0 ? (
                        empresasFiltradas.map((empresa) => (
                          <tr key={empresa.numero_dominio}>
                            <td className="fw-bold">{empresa.numero_dominio}</td>
                            <td className="text-start">{empresa.empresa}</td>
                            <td>{empresa.operador || '-'}</td>
                            <td>
                              {contagensAtivas[empresa.numero_dominio] ? (
                                <div className="d-flex align-items-center justify-content-center">
                                  <span className="badge bg-success me-2 pulse"></span>
                                  <span className="fw-bold text-success tempo-ativo">
                                    {tempoDecorrido[empresa.numero_dominio] || '00:00:00'}
                                  </span>
                                </div>
                              ) : (
                                <span className="text-muted">
                                  <i className="fas fa-pause-circle me-1"></i>
                                  Inativo
                                </span>
                              )}
                            </td>
                            <td>
                              {contagensAtivas[empresa.numero_dominio] ? (
                                <button 
                                  className="btn btn-sm btn-danger" 
                                  onClick={() => pararContagem(empresa)}
                                  title="Parar Contagem"
                                >
                                  <i className="fas fa-stop me-1"></i>
                                  Parar
                                </button>
                              ) : (
                                <button 
                                  className="btn btn-sm btn-success" 
                                  onClick={() => iniciarContagem(empresa)}
                                  title="Iniciar Contagem"
                                >
                                  <i className="fas fa-play me-1"></i>
                                  Iniciar
                                </button>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center py-4 text-muted">
                            <i className="fas fa-search me-2"></i>
                            Nenhuma empresa encontrada com os filtros selecionados.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}

                <div className="mt-3 text-end">
                  <span className="text-muted">
                    <i className="fas fa-list me-1"></i>
                    Total de registros: <strong>{empresasFiltradas.length}</strong>
                  </span>
                </div>
              </div>
            </div>
          )}

          {/* Tab Histórico */}
          {tabAtiva === 'historico' && (
            <div className="tab-pane-content">
              <div className="mb-3">
                <label className="form-label fw-bold">Filtrar Histórico</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Buscar por empresa, usuário ou domínio..."
                  value={filtroHistorico}
                  onChange={(e) => setFiltroHistorico(e.target.value)}
                />
              </div>

              <div className="table-responsive">
                {carregandoHistorico ? (
                  <div className="text-center my-5">
                    <div className="spinner-border text-primary" role="status"></div>
                    <p className="mt-2">Carregando histórico...</p>
                  </div>
                ) : (
                  <table className="table table-bordered table-hover text-center align-middle">
                    <thead className="table-light">
                      <tr>
                        <th>Empresa</th>
                        <th>Início</th>
                        <th>Fim</th>
                        <th>Duração</th>
                        <th>Status</th>
                        <th>Usuário</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {historicoFiltrado.length > 0 ? (
                        historicoFiltrado.map((item) => (
                          <tr key={item.id}>
                            <td className="text-start">{item.empresa}</td>
                            <td>{item.data_inicio}</td>
                            <td>{item.data_fim || '-'}</td>
                            <td className="fw-bold text-primary">{item.duracao}</td>
                            <td>
                              <span 
                                className={`badge ${
                                  item.status === 'Em andamento' 
                                    ? 'bg-warning text-dark' 
                                    : 'bg-success'
                                }`}
                              >
                                <i className={`fas ${item.status === 'Em andamento' ? 'fa-clock' : 'fa-check'} me-1`}></i>
                                {item.status}
                              </span>
                            </td>
                            <td>{item.usuario}</td>
                            <td>
                              {item.status === 'Concluído' && (
                                <div className="btn-group" role="group">
                                  <button 
                                    className="btn btn-sm btn-warning"
                                    onClick={() => abrirModalEdicao(item)}
                                    title="Editar Tempo"
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                  <button 
                                    className="btn btn-sm btn-danger"
                                    onClick={() => deletarRegistroTempo(item)}
                                    title="Deletar Registro"
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </div>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center py-4 text-muted">
                            <i className="fas fa-clock me-2"></i>
                            Nenhum registro de tempo encontrado.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}

                <div className="mt-3 text-end">
                  <span className="text-muted">
                    <i className="fas fa-list me-1"></i>
                    Total de registros: <strong>{historicoFiltrado.length}</strong>
                  </span>
                </div>
              </div>
            </div>
          )}

          {/* Tab Resumo */}
          {tabAtiva === 'resumo' && (
            <div className="tab-pane-content">
              <div className="mb-3">
                <button 
                  className="btn btn-secondary btn-sm me-2"
                  onClick={() => {
                    calcularResumoPorEmpresa(historicoTempo);
                  }}
                >
                  <i className="fas fa-sync me-1"></i>
                  Recalcular
                </button>
                <small className="text-muted">
                  Histórico: {historicoTempo.length} registros | 
                  Resumo: {resumoPorEmpresa.length} empresas
                </small>
              </div>

              <div className="table-responsive">
                <table className="table table-bordered table-hover text-center align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>Nº Domínio</th>
                      <th>Empresa</th>
                      <th>Tempo Total</th>
                      <th>Registros</th>
                      <th>Tempo Médio</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resumoPorEmpresa.length > 0 ? (
                      resumoPorEmpresa.map((item) => (
                        <tr key={item.numero_dominio}>
                          <td className="fw-bold">{item.numero_dominio}</td>
                          <td className="text-start">{item.empresa}</td>
                          <td className="fw-bold text-primary">{item.tempo_total_formatado}</td>
                          <td>
                            <span className="badge bg-info">{item.registros}</span>
                          </td>
                          <td className="text-success">{item.tempo_medio_formatado}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center py-4 text-muted">
                          <i className="fas fa-chart-bar me-2"></i>
                          Nenhum resumo de tempo disponível.
                          <br />
                          <small>Execute pelo menos uma contagem completa para ver os dados.</small>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Modal de Edição de Tempo */}
      {mostrarModalEdicao && (
        <div className="modal" tabIndex="-1" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title mb-0 fw-bold">
                  <i className="fas fa-edit me-2"></i>
                  Editar Tempo - {editandoTempo?.empresa}
                </h5>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={() => setMostrarModalEdicao(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p><strong>Tempo atual:</strong> {editandoTempo?.duracao}</p>
                
                <div className="row">
                  <div className="col-md-4">
                    <label className="form-label">Horas</label>
                    <input
                      type="number"
                      className="form-control"
                      min="0"
                      max="23"
                      value={novoTempo.horas}
                      onChange={(e) => setNovoTempo(prev => ({ ...prev, horas: parseInt(e.target.value) || 0 }))}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Minutos</label>
                    <input
                      type="number"
                      className="form-control"
                      min="0"
                      max="59"
                      value={novoTempo.minutos}
                      onChange={(e) => setNovoTempo(prev => ({ ...prev, minutos: parseInt(e.target.value) || 0 }))}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Segundos</label>
                    <input
                      type="number"
                      className="form-control"
                      min="0"
                      max="59"
                      value={novoTempo.segundos}
                      onChange={(e) => setNovoTempo(prev => ({ ...prev, segundos: parseInt(e.target.value) || 0 }))}
                    />
                  </div>
                </div>
                
                <div className="mt-3">
                  <p><strong>Novo tempo:</strong> {novoTempo.horas}h {novoTempo.minutos}m {novoTempo.segundos}s</p>
                </div>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={() => setMostrarModalEdicao(false)}
                >
                  Cancelar
                </button>
                <button 
                  type="button" 
                  className="btn btn-primary"
                  onClick={salvarEdicaoTempo}
                >
                  <i className="fas fa-save me-2"></i>
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contagemcontabilidade;